import { useParams } from "react-router-dom"
import useGlobalContext from "../context/GlobalContext"
import Slider from "../components/Slider"
import { cultures } from "./Home"
import Footer from "../components/Footer"
import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import Loading from "../components/Loading"
import { useMemo, useState } from "react"
import { slideImg } from "../components/Slide"
import { AnimatePresence, motion } from "framer-motion"
import useCartContext from "../context/CartContext"
import useProducts from "../context/ProductsContext"

const Product = () => {
  const [previewImgIndex, setPreviewImgIndex] = useState(0)
  const [showDesc, setShowDesc] = useState(false)
  const { productId } = useParams()
  const { increaseCartQuantity } = useCartContext()
  const { changeCursor, setOpenCart } = useGlobalContext()
  const { products, isLoading: loadingProducts } = useProducts()

  const { data, isLoading } = useQuery({
    queryKey: ["product", productId],
    queryFn: async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_PRODUCTS_API}/${productId}`
      )
      return res.data
    },
    enabled: productId != null,
  })

  const recommendedSlides = useMemo(() => {
    if (isLoading) return []
    return products
      ?.filter((p) => p.id !== productId)
      ?.sort(() => 0.5 - Math.random())
  }, [products, productId, isLoading])

  return (
    <>
      <section
        data-scroll-section
        onMouseEnter={() => changeCursor("")}
        className="product p-height"
      >
        {isLoading ? (
          <Loading />
        ) : (
          <div className="wrapper">
            <p className="page-tag">
              Home |{" "}
              {data?.product?.categories.map((c) => (
                <span key={c?.id}>{c?.name} | </span>
              ))}
            </p>
            <div className="product-grid" id="c-product-container">
              <div
                className="product-img-container"
                data-scroll
                data-scroll-sticky
                data-scroll-target="#c-product-container"
                onMouseEnter={() => changeCursor("")}
              >
                <div className="product-img-previews">
                  {data?.product?.previews.map((preview, i) => (
                    <img
                      key={i}
                      onClick={() => setPreviewImgIndex(i)}
                      src={preview}
                      alt=""
                      className={previewImgIndex === i ? "selected" : ""}
                    />
                  ))}
                </div>
                <motion.div className="product-img">
                  <AnimatePresence mode="popout">
                    <motion.img
                      key={previewImgIndex}
                      variants={slideImg}
                      initial="hide"
                      animate="show"
                      exit="hide"
                      transition={{ duration: 0.45 }}
                      src={data?.product?.previews[previewImgIndex]}
                      alt=""
                    />
                  </AnimatePresence>
                </motion.div>
              </div>
              <div
                className="product-desc"
                onMouseEnter={() => changeCursor("")}
              >
                <div className="product-desc-cont">
                  <h1 className="title-md">{data?.product.name}</h1>
                  <div className="product-desc-bottom">
                    <div className="product-desc-bottom-flex">
                      <span>Size guide</span>
                      <p>{data?.product?.size.map((s) => s + ", ")}</p>
                    </div>
                    <div className="product-desc-bottom-flex">
                      <span>Available online</span>
                      <span>${data?.product?.price}</span>
                    </div>
                    <div className="product-desc-btns">
                      <button
                        onClick={() => {
                          setOpenCart(true)
                          increaseCartQuantity(data?.product?.id)
                        }}
                        className="btn-cta danger checkout"
                        disabled={isLoading}
                      >
                        Add to Cart
                      </button>
                      <button className="btn-cta wishlist">
                        Add to Wishlist
                      </button>
                    </div>
                  </div>
                </div>
                <div className={`product-desc-desc ${showDesc ? "show" : ""}`}>
                  <div className="product-desc-desc-header">
                    <h1>product description</h1>
                    <div
                      tabIndex={0}
                      className={`cross-btn`}
                      onClick={() => setShowDesc((prev) => !prev)}
                    >
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <p>
                    Kick it in comfort in the Nike Air Force 1. The feel of
                    classic leather and details that made this shoe an icon are
                    sure to make your sneaker style stand out on the street.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <Slider
        title="Recommended"
        padTo
        slides={recommendedSlides?.slice(0, 5)}
        isLoading={loadingProducts || isLoading}
      />
      <Slider title="Culture" culture slides={cultures} />
      <Footer />
    </>
  )
}

export default Product
